export const LOAD_DOCUMENT_CONSTANT = {
  PARENT_MESAGGES: {
    CANCEL_SEND_DOCUMENT: "Cancelado envío del documento!",
    SEND_DOCUMENT_SUCCESSFUL: "Documento enviado correctamente!",
    SEND_DOCUMENT_ERROR: "No fue posible cargar el documento!",
    LOAD_DOCUMENT_ERROR: "No fue posible cargar el documento!",
    LIMIT_SIZE: "El tamaño del archivo no puede superar "
  },
  PARENT_MESAGGES_TYPE: {
    WEBVIEW_READY: "webview.frame.ready",
    WEBVIEW: "webview"
  }
};

export const EVENT_LISTENER: "message" = "message";
